/**
 * Permission configuration.
 *
 * Usage:
 *   hasPermission("configuration_setting.cs_update")       → checks if user has action "cs_update" for feature "configuration_setting"
 *   hasPermission("configuration_setting.cs_view_all")     → menu-level: checks if user can see this feature
 */

/**
 * Maps each feature to its "view all" action used for menu/route visibility.
 * When checking if a user can see a menu item, we check: hasPermission(`${feature}.${VIEW_ACTION_MAP[feature]}`)
 */
export const VIEW_ACTION_MAP: Record<string, string> = {
  executive_overview: "eo_view_all",
  // program: "p_view_all",
  monitor_alert: "ma_view_all",
  intelligent_analysis: "ia_view_all",
  report_agent: "ra_view_all",
  process_optimization: "po_view_all",
  configuration_setting: "cs_view_all",
  permission_management: "pm_view_all",
  notes: "n_view_all",
  program_detail: "pd_view_all"
};
